module.exports = __webpack_public_path__ + "static/media/IMG_4270.06024d67.PNG";